<template>
  <section id="whatDoes" class="services-section">
    <div class="container">
      <!-- La columna izquierda muestra SIEMPRE Automatización y Control -->
      <div class="left">
        <h1 class="section-title">{{ col1.title }}</h1>
        <p class="section-description">{{ col1.description }}</p>
        <!-- Cambia este router-link para que SIEMPRE apunte a /servicios -->
        <router-link to="/servicios" class="services-button" @click="goToServicio()">
          {{ $t ? $t('Ver más') : 'Ver más' }}
        </router-link>
      </div>

      <div class="right">
        <div class="grid-wrapper">
          <!-- Columna 1: automatizacion-de-control -->
          <div class="col col-1">
            <router-link
              v-if="col1"
              :to="col1.link"
              class="service-card full-height"
              @mouseover="hoverIndex = col1.index"
              @mouseleave="hoverIndex = null"
              @click="goToServicio()"
              :class="{ active: hoverIndex === col1.index }"
            >
              <div class="icon-wrap d-flex align-items-center justify-content-center">
                <img
                  :src="hoverIndex === col1.index ? col1.hoverImage : col1.image"
                  :alt="col1.title"
                />
              </div>
              <div class="text-content">
                <h3>{{ col1.title }}</h3>
                <p class="service-desc" v-if="hoverIndex === col1.index">{{ col1.description }}</p>
              </div>
            </router-link>
          </div>

          <!-- Columna 2: industria-4-0 -->
          <div class="col col-2">
            <router-link
              v-if="col2"
              :to="col2.link"
              class="service-card full-height"
              @mouseover="hoverIndex = col2.index"
              @mouseleave="hoverIndex = null"
              :class="{ active: hoverIndex === col2.index }"
              @click="goToServicio()"
            >
              <div class="icon-wrap d-flex align-items-center justify-content-center">
                <img
                  :src="hoverIndex === col2.index ? col2.hoverImage : col2.image"
                  :alt="col2.title"
                />
              </div>
              <div class="text-content">
                <h3>{{ col2.title }}</h3>
                <p class="service-desc" v-if="hoverIndex === col2.index">{{ col2.description }}</p>
              </div>
            </router-link>
          </div>

          <!-- Columna 3: consultoria -->
          <div class="col col-3">
            <router-link
              v-if="col3"
              :to="col3.link"
              class="service-card full-height"
              @mouseover="hoverIndex = col3.index"
              @mouseleave="hoverIndex = null"
              :class="{ active: hoverIndex === col3.index }"
              @click="goToServicio()"
            >
              <div class="icon-wrap d-flex align-items-center justify-content-center">
                <img
                  :src="hoverIndex === col3.index ? col3.hoverImage : col3.image"
                  :alt="col3.title"
                />
              </div>
              <div class="text-content">
                <h3>{{ col3.title }}</h3>
                <p class="service-desc" v-if="hoverIndex === col3.index">{{ col3.description }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { servicios } from '@/assets/data/data.ts';

export default {
  name: 'ServiceGrid',
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      hoverIndex: null
    };
  },
  computed: {
    // Columna 1: Automatización y Control
    col1() {
      const s = servicios['automatizacion-de-control'];
      return s
        ? {
            index: 1,
            key: 'automatizacion-de-control',
            link: s.slugs?.[this.selectedLang] || s.slugs?.es || '#',
            image: s.images?.icon || '',
            hoverImage: s.images?.iconHover || '',
            title: s.titles?.[this.selectedLang] || s.titles?.es || '',
            description: s.descriptions?.[this.selectedLang] || s.descriptions?.es || ''
          }
        : null;
    },
    // Columna 2: Industria 4.0
    col2() {
      const s = servicios['industria-4-0'];
      return s
        ? {
            index: 2,
            key: 'industria-4-0',
            link: s.slugs?.[this.selectedLang] || s.slugs?.es || '#',
            image: s.images?.icon || '',
            hoverImage: s.images?.iconHover || '',
            title: s.titles?.[this.selectedLang] || s.titles?.es || '',
            description: s.descriptions?.[this.selectedLang] || s.descriptions?.es || ''
          }
        : null;
    },
    // Columna 3: Consultoría
    col3() {
      const s = servicios['consultoria'];
      return s
        ? {
            index: 3,
            key: 'consultoria',
            link: s.slugs?.[this.selectedLang] || s.slugs?.es || '#',
            image: s.images?.icon || '',
            hoverImage: s.images?.iconHover || '',
            title: s.titles?.[this.selectedLang] || s.titles?.es || '',
            description: s.descriptions?.[this.selectedLang] || s.descriptions?.es || ''
          }
        : null;
    }
  },
  methods: {
    goToServicio() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
#whatDoes{
  background-image: url('@/assets/images/servicios-bg.png');
  background-size: cover;
}
.services-section {
  padding: 40px 20px;
  background-color: #f8fcfd;
}

/* Layout base (desktop/tablet) */
.container {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: space-between;
  box-sizing: border-box;
}
.left {
  flex: 1;
  min-width: 300px;
  max-width: 500px;
}
.right {
  flex: 2;
  min-width: 300px;
}
.section-title {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2.2rem;
  margin-bottom: 10px;
}
.section-description {
  font-family: 'JetBrainsMono-Regular', monospace;
  font-size: 0.95rem;
  margin-bottom: 20px;
}
.services-button {
  display: inline-block;
  background-color: black;
  color: white;
  padding: 0.4rem 1.2rem;
  border-radius: 999px;
  font-family: 'Caveat-Bold', cursive;
  text-decoration: none;
  font-size: 1rem;
}
.grid-wrapper {
  display: flex;
  gap: 20px;
  width: 100%;
}
.col {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 500px;
}
.col-1,
.col-2,
.col-3 {
  flex: 1;
}
.service-card {
  border: 1px solid black;
  padding: 1.2rem;
  text-align: justify;
  transition: all 0.3s ease;
  background-color: white;
  color: black;
  height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  box-sizing: border-box;
}
.service-card img {
  max-width: 100%;
  height: 80px;
  margin: 0 auto 10px;
  transition: transform 0.3s ease;
}
.text-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.service-card h3 {
  font-family: 'JetBrainsMono-Bold', monospace;
  font-size: 1rem;
  margin-bottom: 5px;
}
.service-card p {
  font-family: 'JetBrainsMono-Regular', monospace;
  font-size: 0.85rem;
  line-height: 1.3;
  margin-top: 10px;
}

/* Hover (base) */
.service-card.active {
  background-color: black;
  color: white;
}
.service-card.active img {
  transform: scale(1.2);
}

/* Altura especial para el card grande */
.full-height {
  height: 100%;
  min-height: 100%;
}

.services-button {
  display: inline-block;
  padding: 0.5rem 1.2rem;
  background-color: #000;
  color: #fff;
  text-decoration: none;
  border-radius: 30px;
  font-family: 'Caveat-Bold', cursive;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}
.services-button:hover {
  background-color: #2c74b8;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  color: #ffffff
}

/* ===========================
   RESPONSIVE: <= 576px (sm)
   =========================== */
@media (max-width: 576.98px) {
  /* Estructura general: todo en columna y ancho completo */
  .container {
    flex-direction: column;
    gap: 24px;
  }
  .left, .right, .grid-wrapper, .col {
    width: 100%;
    max-width: 100%;
  }
  .grid-wrapper {
    flex-direction: column;
    gap: 12px;
  }
  .col {
    min-height: 0;
    gap: 12px;
  }

  /* Tarjetas: filas horizontales uniformes */
  .service-card {
    height: 96px;                 /* alto uniforme */
    min-height: 96px;
    padding: 12px 14px;
    display: flex;
    flex-direction: row;          /* horizontal por default */
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    text-align: justify;
  }

  /* Contenedor de icono con tamaño fijo para uniformidad */
  .icon-wrap {
    width: 56px;
    height: 56px;
    flex: 0 0 56px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .service-card img {
    width: 48px;
    height: 48px;
    margin: 0;                    /* sin auto-centro */
    object-fit: contain;
    transform: none;              /* evita saltos */
  }

  .text-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;                 /* permite truncado si hace falta */
  }
  .service-card h3 {
    font-size: 0.95rem;
    margin: 0;
    line-height: 1.2;
  }
  .service-desc {
    display: none;                /* se muestra solo en hover */
    font-size: 0.82rem;
    line-height: 1.3;
    margin-top: 4px;
  }

  /* En hover: aparece la descripción; el alto puede crecer */
  .service-card:hover .service-desc,
  .service-card.active .service-desc {
    display: block;
  }
}
</style>
